import React, { Component } from "react";
import AsyncSelect from "react-select/lib/Async";

class SearchableSelect extends Component {
  selectInput = React.createRef();

  componentDidMount() {
    if (this.selectInput.current) {
      this.selectInput.current.focus();
    }
  }

  componentDidUpdate() {
    if (this.selectInput.current) {
      this.selectInput.current.focus();
    }
  }

  render() {
    return (
      <AsyncSelect
        getOptionLabel={this.props.getOptionLabel}
        getOptionValue={({ id }) => id}
        loadOptions={this.props.promiseOption}
        value={this.props.value}
        isMulti={this.props.isMulti}
        onChange={option => this.props._handleChangeInSelect(option)}
        placeholder={this.props.placeholder}
        ref={this.selectInput}
        data-test="searchableselect"
      />
    );
  }
}
export default SearchableSelect;



// WEBPACK FOOTER //
// ./src/commonComponents/Searchable/searchableSelect.js